// test8
(8 && 0);
